import React, {useState} from 'react';
import {Box, Select, FormControl, CheckIcon} from 'native-base';

import IDropDownOption from '../../../interfaces/ui/dropdown-option.interface';
import {defaultProps} from '../constants';
import {message} from '../../../utils/messages';
import {isWebApp} from '../../../utils/platform/is-web';

interface DropDownInputProps {
  label: string;
  options: IDropDownOption[];
  onChange?: (value: any) => void;
  isRequired?: boolean;
}

const SimpleDropDown = (props: DropDownInputProps) => {
  const {label, options, onChange: launchOnChange, isRequired} = props;
  const [value, setValue] = useState();

  const getMessage = (text: string) => {
    return message(text).trim();
  };

  const handleOnValueChange = (itemValue: any) => {
    setValue(itemValue);
    if (launchOnChange) {
      launchOnChange(itemValue);
    }
  };

  const defaultMarginWeb = {
    mr: 1,
    ml: 1,
  };

  const getPropertiesWeb = () => {
    if (isWebApp) {
      return defaultMarginWeb;
    }
    ``;
    return {};
  };

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl isRequired={isRequired}>
        <FormControl.Label>{getMessage(label)}</FormControl.Label>
        <Select
          optimized={false}
          _selectedItem={{
            bg: 'blue.200',
            endIcon: <CheckIcon size="5" color="black" />,
          }}
          mt={1}
          {...defaultProps}
          selectedValue={value}
          onValueChange={itemValue => handleOnValueChange(itemValue)}
          fontSize={14}
          {...getPropertiesWeb()}>
          {options.map(option => (
            <Select.Item
              key={option.value}
              label={option.label}
              value={option.value}
            />
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SimpleDropDown;
